module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.99e9ab96.svg";